<mat-dialog-content
    fxLayout="column"
    fxLayoutAlign="center center"
    class="preview-assignable-container"
>
    <div class="preview-assignable-content">
        <assignable-preview-details
            [asset]="asset"
            [embedded]="true"
        ></assignable-preview-details>
        <div fxLayoutAlign="center flex-end" style="padding: 10px">
            <button mat-raised-button color="primary" (click)="onCancel()">
                Close
            </button>
        </div>
    </div>
</mat-dialog-content>
